import { DocumentDownloadIcon, PlusIcon } from "@heroicons/react/outline";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useState } from "react";
import { useLocation } from "react-router-dom";

const CustomTable = ({
  isLoading,
  headerData,
  Data,
  onClickCreate = () => {},
  isAction,
  onSearchData = () => {},
  onClickShow = () => {},
  onEditData = () => {},
  onDeleteData = () => {},
  exportExcel,
  TablePagination,
}) => {
  const location = useLocation();
  const path = location.pathname;
  const [search, setSearch] = useState("");
  return (
    <div className="bg-white rounded-2xl">
     <div className="flex flex-col sm:flex-row justify-between gap-4 sm:items-center py-5 px-5 w-full">
        <input
          id="searchBar"
          name="search"
          type="text"
          value={search}
          placeholder="Search..."
          onChange={(e) => {
            setSearch(e.target.value);
            onSearchData(e.target.value);
          }}
          className="h-11 block px-2 w-full sm:max-w-72 rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
        />
        <div className="flex flex-col sm:flex-row whitespace-nowrap gap-4">
          {exportExcel && (
             <button
             className="h-11 flex w-auto justify-center items-center rounded-xl text-color-talangmas border border-color-talangmas hover:bg-opacity-50 px-3 py-1.5 text-sm font-semibold leading-6 shadow-sm  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
             onClick={exportExcel}
           >
             <DocumentDownloadIcon
               className=" mr-1 flex-shrink-0 h-5 w-5"
               aria-hidden="true"
             />
             Export Excel
           </button>
          )}
          {isAction.isAdd ? (
            <button
              className="h-11 flex w-auto justify-center items-center rounded-xl btn-color-talangmas hover:bg-opacity-50 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
              onClick={onClickCreate}
            >
              <PlusIcon
                className="text-white mr-1 flex-shrink-0 h-5 w-5"
                aria-hidden="true"
              />
              Create New
            </button>
          ) : (
            <div></div>
          )}
        </div>
      </div>
    <TableContainer
      className=""
      style={{
        boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
        border: "0.5px solid #fafafa",
        borderRadius: "10px",
      }}
      component={Paper}
    >
      {path === "/dashboard/home" && (
        <h2 className="font-bold ms-4 mt-4">Daftar Pengguna Masuk</h2>
      )} 

      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead
          sx={{
            fontFamily: "monospace",
            backgroundColor: "#F5F5F7",
            color: "#4C4E64",
          }}
        >
          <TableRow>
            <TableCell align="center" width="5%">
              No
            </TableCell>
            {headerData.map((header, index) => (
              <TableCell
                key={index}
                align={header.align}
                style={{ width: header.width }}
              >
                {header.label}
              </TableCell>
            ))}
            {isAction &&
            (isAction.isShow || isAction.isEdit || isAction.isDelete) ? (
              <TableCell align="center">Action</TableCell>
            ) : null}
          </TableRow>
        </TableHead>

        {isLoading ? (
          <TableBody>
            <TableRow>
              <TableCell
                style={{
                  height: 100,
                }}
                colSpan={headerData.length + 2}
                align="center"
              >
                <p
                  className="text-sm"
                >
                  Memuat Data ...
                </p>
              </TableCell>
            </TableRow>
          </TableBody>
        ) : (
          <TableBody>
            {Data?.length > 0 ? (
              Data.map((row, index) => (
                <TableRow key={index}>
                  <TableCell align="center" width="5%">
                    {index + 1}
                  </TableCell>

                  {headerData.map((data, index) => (
                    <TableCell align="center" key={index}>
                      {row[data.key]}
                    </TableCell>
                  ))}

                  {isAction &&
                  (isAction.isShow || isAction.isEdit || isAction.isDelete) ? (
                    <TableCell align="center">
                      <div className="flex justify-center gap-2">
                        {isAction.isShow ? (
                          <div>
                            <button
                              className="h-10 flex w-auto justify-center items-center rounded-xl bg-btn-login hover:bg-opacity-50 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                              onClick={() => onClickShow(row)}
                            >
                              <i className="ri-eye-line"></i>
                            </button>
                          </div>
                        ) : null}

                        {isAction.isEdit ? (
                          <div>
                            <button
                              className="h-10 flex w-auto justify-center items-center rounded-xl bg-amber-500 hover:bg-opacity-50 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                              onClick={() => onEditData(row)}
                            >
                              <i className="ri-pencil-line"></i>
                            </button>
                          </div>
                        ) : null}

                        {isAction.isDelete ? (
                          <div>
                            <button
                              className="bg-rose-900 h-10 flex w-auto justify-center items-center rounded-xl hover:bg-opacity-50 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                              onClick={() => onDeleteData(row)}
                            >
                              <i className="ri-delete-bin-6-line"></i>
                            </button>
                          </div>
                        ) : null}
                      </div>
                    </TableCell>
                  ) : null}
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell
                  style={{
                    height: 100,
                  }}
                  colSpan={headerData.length + 2}
                  align="center"
                >
                  <p
                    className="text-sm"
                  >
                    Tidak Ada Data
                  </p>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        )}
      </Table>
      {TablePagination}
    </TableContainer>
    </div>
  );
};

export default CustomTable;
